module.exports = __webpack_public_path__ + "img/portugal-cerebrovascular-disease-female.7b9541ff.png";